<template>
  <lazy-component>
    <grid
      vertical="middle"
      :rwd="{ tablet: 'stack', compact: 'stack' }"
      class="blog-post__person"
    >
      <template v-if="loading">
        Loading Author Profile...
      </template>
      <template v-else>
        <template v-if="error">
          Error Loading Author Profile.
        </template>
        <template v-else-if="author">
          <grid-item class="blog-post__person-link">
            <img
              v-if="imageUrl"
              :src="imageUrl"
              class="blog-post__person-image"
            />
            <div class="blog-post__person-name">{{ author.name }}</div>
          </grid-item>
          <grid-item class="divider" />
          <grid-item
            class="blog-post__person-info"
            v-if="author.role || author.twitter"
          >
            <grid :rwd="{ tablet: 'stack', compact: 'stack' }">
              <grid-item v-if="author.role">
                {{ author.role }} at Bohemia Interactive
              </grid-item>
              <template v-if="author.twitter">
                <grid-item
                  class="text-red"
                  :rwd="{ tablet: '0/1', compact: '0/1' }"
                  >/</grid-item
                >
                <grid-item>
                  Twitter:
                  <a
                    target="_blank"
                    :href="`https://twitter.com/${author.twitter}`"
                    rel="noopener noreferrer"
                    >@{{ author.twitter }}</a
                  >
                </grid-item>
              </template>
            </grid>
          </grid-item>
        </template>
      </template>
    </grid>
  </lazy-component>
</template>

<script>
import { AuthorResource } from "@/services";

export default {
  name: "app-author",
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      author: null,
      loading: false,
      error: false
    };
  },
  computed: {
    imageUrl() {
      if (this.author.image) {
        return `/app-static/uploads/author/${this.author.id}/${this.author.image}`;
      }

      return null;
    }
  },
  methods: {
    async fetchData() {
      try {
        const response = await AuthorResource.get({
          id: this.id
        });

        this.author = response.body;
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    await this.fetchData();
  }
};
</script>

<style scoped lang="scss">
@import "./../../../../assets/styles/vars";

$h-padding: 100px;
$screen-big: 1270px;

.divider {
  position: relative;
  height: 100px;

  @media (max-width: 900px) {
    height: 1px;
    width: 100%;
    margin: 15px 0;
  }

  &:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100%;
    left: 0;
    background: $mainRed;

    @media (max-width: 900px) {
      width: 100%;
      height: 1px;
    }
  }
}

.blog-post__person {
  margin: 40px 0;
  padding: 15px 0;
  border-top: 1px solid #313131;
  border-bottom: 1px solid #313131;

  @media (max-width: $screen-big) {
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }
}

.blog-post__person-info {
  color: #808080;
}

.blog-post__person-image {
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  width: 75px;
  height: 75px;
  margin-right: 15px;
  border-radius: 50%;
}

.blog-post__person-name {
  display: inline-block;
  vertical-align: middle;
  font-family: $sarala;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: $mainRed;
  padding: 0 16px 0 10px;
  line-height: 66px;
  transition: all 0.3s;

  @media (max-width: $screen-xs-max) {
    border-right: 0;
  }

  @media (max-width: $screen-xs) {
    display: block;
    line-height: 1.2;
    margin-top: 15px;
  }
}
</style>
